import React, { useState, useEffect } from "react";
import { invitationTemplateEventName } from "../../util/invitationTemplateCatalog";
import HostNameDialog from "../eventComponent/EventTabs/HostNameDialog";
import ChooseTemplateDialog from "../eventComponent/EventTabs/ChooseTemplateDialog";
import SendInvitationDialog from "../eventComponent/EventTabs/SendInvitationDialog";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";
import config from "../../config";
import debuglog from "../../util/helperutil";
import { fetchinvitationtemplates,getinvitation_templates_by_category } from "../../Apiservices/Auth/servers/fetchinvitationtemplates";
import { RSVPInvitationPage_pooja } from "../RSVPInvitationPage/poojainvitationpage/RsvpInvitationpage_pooja";
// Function to update the event on the server (your API)
import { updateEvent } from "../../Apiservices/Auth/servers/createEvents";
// const updateEvent = async (eventData, eventId) => {
//   console.log("adding",eventData)
//   try {
    
//     const response = await fetch(`/api/events/${eventId}`, {
//       method: "PATCH",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(eventData),
//     });
//     const data = await response.json();

//     if (response.ok) {
//       return data;
//     } else {
//       throw new Error("Failed to update event.");
//     }
//   } catch (error) {
//     console.error("Error updating event:", error);
//     return null;
//   }
// };

const SendInvitation = ({ event, onClose }) => {
  console.log("eventdetailsinvite", event);
  const [inviteDialogVisible, setInviteDialogVisible] = useState(false);
  const [invitedByInputDialogVisible, setInvitedByInputDialogVisible] = useState(false);
  const [wasDialogClosed, setWasDialogClosed] = useState(false);
  const [hostName, setHostName] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);
    const [EventDataForInvitation, setEventDataForInvitation] = useState({});
  const [imagetemplateslength, setimagetemplateslength] = useState(0);
  const screensize = window.innerWidth;
  const [imageloading, setimageloading] = useState(false);
  const [selectedtemplate, setselectedtemplate] = useState();
    const [haschoosentemplate, sethaschoosentemplate] = useState(
        !!event?.imagePath?.trim()
      );
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selected_templateerror, setselected_templateerror] = useState("");
  const [eventimages, seteventimages] = useState([]);
   const [isInvitedByExists, setIsInvitedByExists] = useState(
        !!event?.invitedBy?.trim()
      );
  const shareToken = event?.shareToken;
  const shareUrl = `${config.INVITATION_URL}/${shareToken}`;
  const shareTitle = `Check out this event: ${event?.eventTitle}`;
  const whatsappMessage = encodeURIComponent(`${shareTitle} ${shareUrl}`);
    const [chooselabelforinvitation, setchooselabelforinvitation] = useState(false);
    const [chooseTemplateLoading, setChooseTemplateLoading] = useState(false); 
      const [imageFromEventPath, setImageFromEventPath] = useState(null);
const callsomefunction = async (selectedImagePath) => {
  setimageloading(true);
 
  // Prepare event data upfront
  const data = {
    eventName: event.eventTitle || "",
    eventCategoryName: event.EventMasterDetails?.eventCategoryName || "",
    eventType: event.eventTitle || "",
    eventTitle: event.eventTitle || "",
    invitedBy: hostName || event?.invitedBy || "",
    description: event.description || "",
    startDate: event.Date || "",
    startTime: event.startTime || "",
    endDate: event.endDate || "",
    endTime: event.endTime || "",
    city: event.city || "",
    area: event.area || "",
    state: event.state || "",
    venue: event.Location || "",
    locationLat: event.locationLat || "",
    locationLong: event.locationLong || "",
    caste: event.caste || null,
    religion: event.religion || null,
    language: event.language || null,
    region: event.region || null,
  };
  console.log("got here",data)
  // Set event data immediately so UI always has it
  setEventDataForInvitation(data);

  try {
    const category_name = data.eventCategoryName;
    const screenType = screensize > 800 ? "web" : "mobile";

    // Fetch templates (may return null)
    let fetch_api_image = null;
    console.log("calling",category_name,
        event.eventTitle,
        screenType)
    try {
      fetch_api_image = await fetchinvitationtemplates(
        category_name,
        invitationTemplateEventName(event),
        screenType
      );

    } catch (err) {
      console.warn("Error fetching templates:", err);
      fetch_api_image = null;
    }

    // Load images safely, fallback to empty array if null
    const imagetrial = await load_all_category_images(fetch_api_image?.images || []);
    console.log("eventimages",imagetrial)
     if (selectedImagePath) {
    seteventimages(imagetrial);
    setimagetemplateslength(imagetrial.length);
    setCurrentIndex(0);

    const matchedImage = imagetrial.find(img => img.name === selectedImagePath);
    console.log("matchedImage (using selectedImagePath)", matchedImage, selectedImagePath);
    setImageFromEventPath(matchedImage?.url || imagetrial[0]?.url || null);
  } else {
    seteventimages(imagetrial);
    setimagetemplateslength(imagetrial.length);
    setCurrentIndex(0);

    const matchedImage = imagetrial.find(img => img.name === event.imagePath);
    console.log("matchedImage (using event.imagePath)", matchedImage, event.imagePath);
    setImageFromEventPath(matchedImage?.url || imagetrial[0]?.url || null);
  }


  } catch (error) {
    console.warn("Unexpected error in image fetching:", error);
    // Still continue, event data is already set
  } finally {
    setimageloading(false);
  }
};
           const load_all_category_images = async (imagesMeta) => {
             const imageResults = [];
             try {
               for (const img of imagesMeta) {
                 const fullUrl = `/templates-bg/${img.url}`;
                 const blob = await getinvitation_templates_by_category(fullUrl);
                 if (blob) {
                   const blobUrl = URL.createObjectURL(blob); // use directly
                   imageResults.push({ name: img.name, url: blobUrl });
                 }
               }
             } catch (error) {
               console.warn("Error loading category images:", error);
             }
             return imageResults;
           };
  
    const toggleShareOptions = () => {
      console.log(haschoosentemplate, "isInvitedByExists", isInvitedByExists);
      if (isInvitedByExists) {
         

        if (!haschoosentemplate) {
          setChooseTemplateLoading(true);          
          callsomefunction();
           setChooseTemplateLoading(false);
          setchooselabelforinvitation(true);
        } else if (haschoosentemplate) {
          callsomefunction();
          setInviteDialogVisible(true);
        }
      } else if (haschoosentemplate) {
        callsomefunction();

        setInviteDialogVisible(true);
      }
 
      else {
        setInvitedByInputDialogVisible(true);
      }
    };

  useEffect(() => {
    if (event && event.eventTitle && !wasDialogClosed) {
      toggleShareOptions();
    }
    return () => {
      // Clean up when the component is unmounted or dialog is closed
      setWasDialogClosed(true);
    };
  }, [event]);

  const hideDialog = () => {
    debuglog("called onclose")
    setInviteDialogVisible(false);
  if (onClose) {
    // Trigger the onClose callback when hiding the dialog
    onClose({ status: "closed" });
  }
  };
  const hideHostNameDialog = () => {
    debuglog("called onclose")
    setInvitedByInputDialogVisible(false);
    if (onClose) {
      onClose({ status: "cancelled" });
    }
  };
  const showAgain = () => {
    setWasDialogClosed(false);
    toggleShareOptions();
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      } else {
        console.error("Fallback copy failed.");
      }
    } catch (err) {
      console.error("Fallback: Unable to copy", err);
    }
    document.body.removeChild(textArea);
  };
     const handletemplatesubmit = async (templateName) => {
       // if (!templateName) {
       //   setselected_templateerror("please choose the template");
       //   return;
       // }
     
       console.log("selectedtemplate", templateName);
     
       try {
         const eventData = {
           imagePath: templateName,
         };
         const success = await updateEvent(eventData, event.id);
     
         if (success) {
           console.log("Event updated successfully.");
           sethaschoosentemplate(true);
           setchooselabelforinvitation(false);
           setInviteDialogVisible(true);
           callsomefunction(templateName)
         } else {
           console.error("Failed to update event.");
         }
       } catch (error) {
         console.error("An error occurred while saving the host name", error);
         setchooselabelforinvitation(false);
       }
     };
          const handleNext = () => {
      setCurrentIndex((prev) => (prev + 1) % eventimages.length);
    };

    const handlePrev = () => {
      setCurrentIndex(
        (prev) => (prev - 1 + eventimages.length) % eventimages.length
      );
    };
  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl)
        .then(() => {
          setCopySuccess(true);
          setTimeout(() => setCopySuccess(false), 2000);
        })
        .catch((err) => {
          console.error("Clipboard API failed, using fallback...", err);
          fallbackCopyTextToClipboard(shareUrl);
        });
    } else {
      fallbackCopyTextToClipboard(shareUrl);
    }
  };

  const handleShare = (platform) => {
    let url = "";
    const text = `${shareTitle} ${shareUrl}`;

    switch (platform) {
      case "whatsapp":
        url = `https://wa.me/?text=${encodeURIComponent(text)}`;
        break;
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case "gmail":
        url = `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareUrl)}`;
        break;
      default:
        return;
    }

    window.open(url, "_blank");
  };

  // Full implementation of handleHostNameSubmit
   const handleHostNameSubmit = async (hostName, eventId) => {
        try {
          // Call your API here to save the hostName
          const eventData = {
            invitedBy: hostName,
          };
          const success = await updateEvent(eventData, eventId);
  
          if (success) {
            // Perform operations if the event was successfully updated
            console.log("Event updated successfully.");
            setIsInvitedByExists(true);
            // setInviteDialogVisible(true);
            setInvitedByInputDialogVisible(false);
            callsomefunction();
          } else {
            // Handle the failure case
            console.error("Failed to update event.");
          }
        } catch (error) {
          // Handle any errors (e.g., network issues)
          console.error("An error occurred while saving the host name", error);
          setInvitedByInputDialogVisible(false);
        }
      };

  return (
    <>
            <SendInvitationDialog
  visible={inviteDialogVisible}
  onHide={hideDialog}
  shareUrl={shareUrl}
  shareTitle={shareTitle}
  whatsappMessage={whatsappMessage}
    image={imageFromEventPath} 
    imageloading = {imageloading}
    EventDataForInvitation={EventDataForInvitation}
/>
    <ChooseTemplateDialog
  visible={chooselabelforinvitation}
  onHide={() => setchooselabelforinvitation(false)}
  selectedTemplate={selectedtemplate}
  setSelectedTemplate={setselectedtemplate}
  selectedTemplateError={selected_templateerror}
  handleTemplateSubmit={handletemplatesubmit}
  imageloading={imageloading}
  eventimages={eventimages}
  currentIndex={currentIndex}
  handlePrev={handlePrev}
  handleNext={handleNext}
  imagetemplateslength={imagetemplateslength}
  EventDataForInvitation={EventDataForInvitation}
  loadingOverlay={chooseTemplateLoading} 
/>
        <HostNameDialog
  visible={invitedByInputDialogVisible}
  onHide={() => setInvitedByInputDialogVisible(false)}
  hostName={hostName}
  setHostName={setHostName}
  onSubmit={() => {
    handleHostNameSubmit(hostName, event.id);
    setInvitedByInputDialogVisible(false);
    setchooselabelforinvitation(true);
  }}
/>
      {/* <Dialog
        header="Invite"
        visible={inviteDialogVisible}
        style={{ width: "calc(100% - 15px)", maxWidth: "500px" }}
        modal
        onHide={hideDialog}
        headerStyle={{ margin: 0, padding: "15px 25px" }}
      >
        <div className="p-fluid">
          <div className="p-inputgroup mb-3">
            <div style={{ position: "relative", width: "100%" }}>
              <InputText
                value={shareUrl}
                readOnly
                style={{ flexGrow: 1, width: "100%", paddingRight: "58px" }}
              />
              <Button
                id="info-icon"
                label={copySuccess ? "Copied" : "Copy"}
                icon="pi pi-copy"
                onClick={handleCopy}
                style={{
                  position: "absolute",
                  right: "0",
                  borderRadius: "0 6px 6px 0",
                  backgroundColor: copySuccess ? "#FF895D" : "#0cc0df",
                }}
              />
              <Tooltip
                position="mouse"
                at="right+5 bottom"
                target="#info-icon"
                content="You can use this link to send invitation using any other method."
              />
            </div>
          </div>

          <div style={{ marginTop: "10px" }}>
            <label style={{ display: "block", marginBottom: "10px" }}>
              Share on Social Media
            </label>
            <div style={{ display: "flex", gap: "10px" }}>
              <Button icon="pi pi-whatsapp" onClick={() => handleShare("whatsapp")} style={{ backgroundColor: "#25D366" }} />
              <Button icon="pi pi-facebook" onClick={() => handleShare("facebook")} style={{ backgroundColor: "#3B5998" }} />
              <Button icon="pi pi-twitter" onClick={() => handleShare("twitter")} style={{ backgroundColor: "#1DA1F2" }} />
              <Button icon="pi pi-envelope" onClick={() => handleShare("gmail")} style={{ backgroundColor: "#1DA1F2" }} />
            </div>
          </div>
        </div>
      </Dialog> */}
       {/* <Dialog
        header="Choose the Template"
        visible={chooselabelforinvitation}  
        modal
        onHide={() => setchooselabelforinvitation(false)}
        className="template-dialog"
        footer={
          <div >
            <p style={{color:"red"}}>{selected_templateerror}</p>
            <Button 
            label={selectedtemplate?"submit":"choose this template"}
            icon="pi pi-check"
            onClick={()=>handletemplatesubmit()}/>
          </div>
        }
      >
        <> {imageloading?( <h3 style={{ textAlign: "center" }}>
                          <i
                            className="pi pi-spin pi-spinner-dotted"
                            style={{ fontSize: "2rem", color: "#0cc0df" }}
                          ></i>
                        </h3>):(
        <div className="image preview">
        <div className="image-select-radio">
          <label>
            <input
              type="radio"
              name="selectedImage"
              value={eventimages[currentIndex]?.name}
              checked={selectedtemplate === eventimages[currentIndex]?.name}
              onChange={() => setselectedtemplate(eventimages[currentIndex]?.name)}
            />
            Select this image
          </label>
        </div>
        <div className="single-image-container">
          
              
        <div className="image-counter">
          {currentIndex + 1} / {eventimages.length}
        </div>
        
        
                        <div style={{ pointerEvents: "none", userSelect: "none" }}>
                          <div className="rsvp-wrapper-scaled">
                            <div className="rsvp-scaled-inner">
                              <RSVPInvitationPage_pooja
                                EventDataForInvitation={EventDataForInvitation}
                                imageUrl_as_prop={eventimages[currentIndex]?.url}
                              />
                            </div>
                          </div>
                        </div>
                        {imagetemplateslength > 1 && (
                          <div className="arrow-controls">
                            <Button
                              icon="pi pi-chevron-left"
                              onClick={handlePrev}
                              className="arrow-button"
                            />
                            <Button
                              icon="pi pi-chevron-right"
                              onClick={handleNext}
                              className="arrow-button"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
            
              </Dialog> */}
      {/* <Dialog
        // header="Enter Host Name"
        visible={invitedByInputDialogVisible}
        style={{ width: "calc(100% - 15px)", maxWidth: "400px" }}
        modal
        onHide={hideHostNameDialog}
        footer={
          <div>
            <Button
              label="Submit"
              icon="pi pi-check"
              onClick={() => {
                handleHostNameSubmit(hostName, event.id);
                setInvitedByInputDialogVisible(false);
                setchooselabelforinvitation(true);
                setInviteDialogVisible(true);
              }}
              disabled={!hostName.trim()}
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={hideHostNameDialog}
              className="p-button-secondary"
            />
          </div>
        }
      >
        <div>
          <label style={{ display: "block", marginBottom: "10px" }}>
            Host Name<span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            value={hostName}
            onChange={(e) => setHostName(e.target.value)}
            placeholder="Enter host name"
            style={{ width: "100%" }}
          />
        </div>
      </Dialog> */}
    </>
  );
};

export default SendInvitation;
